var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeOfDayEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Time Of Day Events",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time Of Day Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0123,10.5c0,5.8-9.997,14.5-9.997,14.5C10.0153,25,.01825,16.3,.01825,10.5-.11646,4.84036,4.35748,.1413,10.0153,0c5.6578,.1413,10.1318,4.84036,9.997,10.5Z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,4c-3.3137,0-6,2.6863-6,6s2.6863,6,6,6,6-2.6863,6-6c-.0036-3.31219-2.6878-5.99635-6-6Zm2.5152,8.5145c-.1465,.1463-.3838,.1463-.5302,0l-2.2501-2.2501c-.07043-.0702-.11002-.1656-.11002-.26506v-3.3748c0-.20718,.16795-.37512,.37512-.37512,.2072,0,.3751,.16796,.3751,.37512v3.21971l2.1401,2.14005c.1461,.1467,.1458,.3839-.0007,.5302h.0007Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOfDayEventsPoint);
export default __webpack_public_path__ + "static/media/time-of-day-events-point.02f5f1eab611a070e6fe808ee4587334.svg";
export { ForwardRef as ReactComponent };